import { createFileRoute, Link } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { ShieldX } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/modulo-nao-contratado/')({
  component: ModuloNaoContratado,
})

function ModuloNaoContratado() {
  return (
    <>
      <Header fixed>
        <div className='ms-auto flex items-center space-x-4'>
          <ProfileDropdown />
        </div>
      </Header>
      <Main className='flex flex-1 items-center justify-center'>
        <Card className='p-8 max-w-md text-center space-y-4'>
          <ShieldX className='w-12 h-12 text-muted-foreground mx-auto' />
          <h2 className='text-xl font-bold'>Módulo não contratado</h2>
          <p className='text-muted-foreground'>
            Sua empresa não contratou este módulo. Entre em contato com o comercial para saber mais.
          </p>
          <Button asChild variant='outline'>
            <Link to='/documentos'>Voltar</Link>
          </Button>
        </Card>
      </Main>
    </>
  )
}
